import React from 'react';
import styled from 'styled-components';

import { Icon, DropDownMenu, DropDownMenuItem } from 'ui/components/shared';
import { useUser } from 'hooks';

export const Badge = ({ listDirection = 'bottom', isSidebar = false }) => {
  const dropdownRef = React.useRef();
  const [preventSignout, setPreventSignout] = React.useState(false);
  const { user, isLoggedIn, signOut, redirectTo } = useUser();
  const username = React.useMemo(() => user?.name?.full, [user]);

  const handleSignout = async () => {
    if (!isLoggedIn) return;
    setPreventSignout(true);
    const result = await signOut();
    if (result) return;
    setPreventSignout(false);
  };

  return (
    <Wrapper
      title={user.email}
      onClick={(event) => dropdownRef?.current.handleClick(event)}
      isSidebar={isSidebar}
    >
      <DropDownMenu
        ref={dropdownRef}
        label={username}
        icon={(props) => <CaretIcon {...props} color={isSidebar ? '#f5f9ff' : '#37517e'} />}
        fixedLeftSpacing={15}
        listContainerProps={{ mt: '12px', pos: 'top' }}
        listProps={{ boxShadow: 'thin' }}
        listDirection={listDirection}
      >
        <DropDownMenuItem onClick={() => redirectTo('/settings')}>
          <Icon icon="settings" size="16px" mr="7px" /> Settings
        </DropDownMenuItem>
        <DropDownMenuItem onClick={handleSignout} disabled={preventSignout}>
          <Icon icon="logout" size="18px" mr="7px" /> Sign out
        </DropDownMenuItem>
      </DropDownMenu>
    </Wrapper>
  );
};

const Wrapper = styled.span`
  display: flex;
  padding: 7px 14px;
  border-radius: 8px;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  font-size: 14px;
  letter-spacing: 0.04em;
  text-align: left;
  background-color: #f5f9ff;
  color: #37517e;
  cursor: pointer;
  ${({ isSidebar }) =>
    isSidebar &&
    `
    background-color: #37517e;
    border: 1px solid #f5f9ff;
    width: 100%;
    padding: 1rem;
    color: #f5f9ff;
    justify-content: left;
  `}
`;

const CaretIcon = ({ color = '#37517e' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="5" viewBox="0 0 8 5">
    <path
      id="Polygone_6"
      data-name="Polygone 6"
      d="M4,0,8,5H0Z"
      transform={`translate(8 5) rotate(180)`}
      fill={color}
    />
  </svg>
);
